import angular from 'angular';

import '../../../core/main/filter/payment_type/filter'
import '../../../core/main/filter/order_status/filter'
import './style.scss';

document.write(require('./view.html').default);

angular.module("merchant.application.module.order.summary", [
]).controller("merchant.application.module.order.summary.controller", [
    "$rootScope", "$scope", "$controller",
    function($rootScope, $scope, $controller) {
        $controller("merchant.application.module.controller", {$scope: $scope});

        if (! $scope.model.orderSummary) {
            $scope.model.orderSummary = {};
        }

        $scope.isApproved = function() {
            return $scope.model.orderSummary && $scope.model.orderSummary.status === "APPROVED";
        };

        $scope.isDeclined = function() {
            return $scope.model.orderSummary && $scope.model.orderSummary.status === "DECLINED";
        };

        $scope.isFailed = function() {
            return $scope.model.orderSummary && $scope.model.orderSummary.status === "FAILED";
        };

    }
]);
